import { useGLTF } from "@react-three/drei";
import { isMobile } from "react-device-detect";
import React, { useRef, useState } from "react";
import { stageObject } from "../../interface";
import { HoverText } from "../../HoverText";
import { useFrame } from "@react-three/fiber";

export const Senior = ({
  url,
  scale,
  position,
  getCharacters,
}: stageObject) => {
  const { scene } = useGLTF(url, "/draco/");
  const seniorRef = useRef<any>();
  const textRef = useRef<any>();
  const pointLightRef = useRef<any>();
  const [hovered, setHovered] = useState(false);

  // 鼠标移入时显示光源和文本
  const handlePointerOver = () => {
    if (pointLightRef.current) {
      pointLightRef.current.visible = true;
    }
    if (textRef.current && !isMobile) {
      textRef.current.visible = true;
    }
  };

  // 鼠标移出时隐藏光源和文本
  const handlePointerOut = () => {
    if (pointLightRef.current) {
      pointLightRef.current.visible = false;
    }
    if (textRef.current) {
      textRef.current.visible = false;
    }
  };

  useFrame(() => {
    if (textRef.current) {
      if (isMobile) {
        textRef.current.visible = true;
        textRef.current.fontSize = "0.2";
        textRef.current.position.set(-1.8, 1.6, -1.8);
      } else {
        textRef.current.position.set(-2.5, 2.3, 0.1);
      }
    }
  });
  return (
    <>
      <primitive
        ref={seniorRef}
        object={scene}
        position={position}
        scale={scale}
        onClick={() => getCharacters("senior")}
        onPointerOver={handlePointerOver}
        onPointerOut={handlePointerOut}
      />

      <pointLight
        ref={pointLightRef}
        visible={isMobile}
        position={[-2.2, 1.8, -1.5]}
        intensity={2}
        color={"#ffcc00"}
      />
      <HoverText text={"Universe"} color={"#32CD32"} textRef={textRef} />
    </>
  );
};
